// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pk-c";
export var backButton = "_pk-4";
export var backIcon = "_pk-5";
export var chevronShortcut = "_pk-6";
export var container = "_pk-1";
export var editor = "_pk-8";
export var editorWrapper = "_pk-7";
export var prefix = "_pk-2";
export var searchIcon = "_pk-3";
export var suffix = "_pk-9";
export var suffixContent = "_pk-a";
export var suffixText = "_pk-b";
export var wrapper = "_pk-0";